import React, {Component} from "react";
import NavBar from "../components/NavBar";
import SideBar from "../components/SideBar";
import Footer from "../components/Footer";
import InquiryList from "../components/InquiryList";
import InquiryForm from "../components/InquiryForm";
import * as ServiceLogin from "../service/ServiceLogin";

class InquiryManagement extends Component {
    constructor(props) {
        super(props);

        this.state = {
            viewMode : "list",
            inquiryData : "",
            filter: "",
            filtered:1,
            nowPage: 0,
        }

        this.handlerListInquiries = this.handlerListInquiries.bind(this);
        this.handlerDetailInquiry = this.handlerDetailInquiry.bind(this);
        this.handlerOnChange = this.handlerOnChange.bind(this);
        this.handlerOnSearch = this.handlerOnSearch.bind(this);
        this.handlerOnPage = this.handlerOnPage.bind(this);

        this.innerConstructor();
    }

    preRender() {
        console.log("DashBoard.js : preRender : rendering");
    }

    innerConstructor() {
        ServiceLogin.svcLoginCheck();
        console.log("UserManagement.js : innerConstructor : end");
    }


    handlerListInquiries() {
        this.setState({viewMode:"list"});
        this.setState({filter:''})
    }

    handlerDetailInquiry(id) {
        this.setState({viewMode:"detail",inquiryData:id});
    }
    handlerOnChange(event){
      this.setState({filter:event.target.value});
    }
    handlerOnSearch(event){
      event.preventDefault();
      this.setState({filtered: this.state.filtered+1})
    }
    handlerOnPage(page){
      this.setState({nowPage: page})
    }

    render() {
        this.preRender();
        return (
            <div>
                <NavBar />
                <div className="container-fluid">
                    <div className="row">
                        <SideBar />
                        <main className="col-md-9 ml-sm-auto col-lg-10 pt-3 px-4">
                            { this.state.viewMode === "list" &&
                                <div>
                                    <h2>문의 관리</h2>
                                    <form onSubmit={this.handlerOnSearch}>
                                        <div className="input-group mb-3">
                                          <input type="text" className="form-control" placeholder="아이디 입력..." value={this.state.filter} onChange={this.handlerOnChange} aria-label="Filter" aria-describedby="basic-addon2"/>
                                             <div className="input-group-append">
                                                <button className="btn btn-outline-secondary" type="submit">검색</button>
                                             </div>
                                        </div>
                                    </form>
                                    <div key={this.state.filtered}>
                                        <InquiryList callBackForUpdate={this.handlerUpdateUser} callBackForDetail={this.handlerDetailInquiry} filter={this.state.filter} callBackForPageChange={this.handlerOnPage} pageNow={this.state.nowPage}/>
                                    </div>
                                </div>
                            }
                            {
                                this.state.viewMode === "detail" &&
                                <div>
                                    <h2>문의</h2>
                                    <div className="col-md-12 text-right mb-3">
                                        <button className="btn btn-outline-primary btn-sm" onClick={this.handlerListInquiries}>문의 내역</button><br />
                                    </div>
                                    <div>
                                        <InquiryForm inquiryData={this.state.inquiryData}/>
                                    </div>
                                </div>
                            }
                        </main>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default InquiryManagement;
